import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Location from "../components/Location"

const IndexPage = () => (
  <Layout>
    <SEO
      title="Les infos pratiques du restaurant hara kiri ramen"
      description="Toutes les informations nécessaire pour venir déguster un bon ramen"
    />
    <Location />
  </Layout>
)

export default IndexPage
